import { http } from 'vue'

export default {
  postContact (context, params = {}) {
    return http.post('contacts', params.data)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/contact/actions.js